<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st6"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('deploy_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('deploy_add_button')"
          @click="funcAdd"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('deploy_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :loading="loading"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="title"
          title="标题"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.title"
            placeholder="请输入标题"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="类型"
          min-width="100"
          sortable
        >
          <template v-slot="{row}">
            {{ dicts.siteDeploy[row.type] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.type"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(v,k) in dicts.siteDeploy"
              :key="k"
              :label="v"
              :value="k"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
        
        title="操作"
        fixed="right"
        width="150"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('deploy_detail_button')"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(scope.row.code)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('deploy_edit_button')"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code)"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('deploy_delete_button')"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDelete(scope.row.code)"
            >
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="600"
      height="600"
      resize
    >
      <compAdd
        ref="addRef"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="600"
      height="600"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="600"
      height="600"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
  import compAdd from "./components/siteDeployAdd.vue";
  import compEdit from "./components/siteDeployEdit.vue";
  import compDetail from "./components/siteDeployDetail.vue";
  import request from "@/utils/request";
  import { getDictByType } from "@/api/commonApi";

  export default {
    name: "SiteDeployList",
    components: {
      compAdd,
      compEdit,
      compDetail
    },
    data() {
      return {
        message: "",
        loading: false,
        tableData: [],
        modelAddFlag: false,
        modelEditFlag: false,
        modelDetailFlag: false,
        copy: false,
        exportObj:{
          exportUrl:"/ntocc-basic-api/siteDeploy/exportSiteDeploy",//导出接口
          name:'门户配置'
        },
        listQuery: {
          code: "",
          branchCode: "",
          title: "",
          img: "",
          type: "",
          idx: "",
          url: "",
          status: "",
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0
        },
      };
    },
    async created() {
       this.dicts = { siteDeploy: {} };
       this.dicts = await getDictByType("siteDeploy");
      this.findList();
         request({ url: '/ntocc-basic-api/siteDeploy/treeData', method: 'get', params: {} }).then(response => {
        this.options = response.data;
      });
    },
    methods: {
      findList() {
        this.loading = true;
        return new Promise(resolve => {
          request({
            url: "/ntocc-basic-api/siteDeploy",
            method: "get",
            params: this.listQuery
          }).then(response => {
            this.tableData = response.data.records;
            this.listQuery.total = response.data.total;
            this.loading = false;
            resolve();
          });
        });
      },
      // 添加方法
      funcAdd() {
        this.$refs.addRef.init(this.dicts,this.options);
        this.modelAddFlag = true;
      },
      // 修改方法
      funcEdit(code) {
        this.$refs.editRef.getInfo(code, this.dicts,this.options);
        this.modelEditFlag = true;
      },
      // 详情方法
      funcDetail(code) {
        this.$refs.detailRef.getInfo(code, this.dicts,this.options);
        this.modelDetailFlag = true;
      },
      // 删除方法
      funcDelete(row) {
        this.$confirm("确认删除吗？")
          .then(_ => {
            request({
              url: `/ntocc-basic-api/siteDeploy`,
              method: "delete",
              params: { codes: row }
            }).then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.findList();
            });
          })
          .catch(_ => {});
      },
      // 增加组件的父方法
      fatherAdd() {
        this.modelAddFlag = false;
        this.findList();
      },
      // 编辑组件的父方法
      fatherEdit() {
        this.modelEditFlag = false;
        this.findList();
      },
      // 公共取消
      fatherCancel(modelFlag) {
        switch (modelFlag) {
          case "add":
            this.modelAddFlag = false;
            break;
          case "edit":
            this.modelEditFlag = false;
            break;
          case "detail":
            this.modelDetailFlag = false;
            break;
          default:
        }
      },
      // 设置底部合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return "合计";
            }
            if (["pageviews", "forecast"].includes(column.property)) {
              return this.$XEUtils.sum(data, column.property);
            }
            return null;
          })
        ];
      }
    }
  };
</script>

<style>

</style>
